<template>
        <div id="app">
            <ckeditor :editor="editor" @ready="onReady" ></ckeditor>

            <v-text-field  v-model="nombre" dense outlined placeholder="Nombre"></v-text-field>
            <v-text-field v-model="descripcion" dense outlined placeholder="Descripcion"></v-text-field>

            <v-btn color="primary" @click="guardar" >Guardar</v-btn>
        </div>
            
</template>

<script>
    import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
    import axios from 'axios'
    export default {
        name: 'app',
        data() {
            return {
                editor: DecoupledEditor,
                nombre:'',
                descripcion:'',
            };
        },
        methods: {
            onReady( editor )  {
                // Insert the toolbar before the editable area.
                editor.ui.getEditableElement().parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );
            },
            guardar(){

                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                let me=this;
                axios.post('api/pruebas/Crear',{
                    'nombre':me.nombre,
                    'descripcion':me.descripcion,
                },configuracion).then(function(response){
                   me.limpiar();
                   //window.alert('Informacion Guardada Correctamente');
                }).catch(function(error){
                    console.log(error);
                }); 
            },
            limpiar(){
                this.nombre = '';
                this.descripcion = '';
            }
        }
    }
</script>